import type React from 'react';
import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { UserProvider } from '../../../common/contexts/UserContext';
import { VhostProvider } from '../../../common/contexts/VhostContext';
import { setCSRF } from '../../../common/services/csrf/CSRFService';
import defaultTheme from '../../../PlekReact/designSystem/theme/defaultTheme';

export interface LoginWrapperProps {
	children: React.ReactNode;
}

const GlobalStyle = createGlobalStyle`
	body {
		// todo: write a correct type for theme
		background: ${({ theme }: any) => (theme.login.backgroundImage ? `url(${theme.login.backgroundImage}) no-repeat center bottom / cover fixed` : '')};
		background-color: ${({ theme }: any) => theme.login.backgroundColor || ''};
	}
`;

export const LoginWrapper: React.FC<LoginWrapperProps> = ({ children }) => {
	useEffect(() => {
		// Initialize CSRF token before any POST requests
		setCSRF();
	}, []);

	return (
		<BrowserRouter>
			<VhostProvider>
				<UserProvider>
					<ThemeProvider theme={defaultTheme}>
						<GlobalStyle />

						{children}
					</ThemeProvider>
				</UserProvider>
			</VhostProvider>
		</BrowserRouter>
	);
};
